import { eventNames, useCoreEvents } from '@carvana/core-events';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import { useModalContext } from '~/context/flp/ModalContext/ModalContext';
import useRefreshTerms from '~/hooks/flp/services/useRefreshTerms';

const OPEN_SOFTPULL_QUERY_PARAM = 'openSoftpullModal';

export default function useSoftpullModalEvents(isMarketingPage?: boolean) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const isNative = useIsNative();
  const refreshTerms = useRefreshTerms();
  const { setSoftPullModalOpen } = useModalContext();
  const softpullSuccessState = useRef(false);

  const clearSoftpullQueryParam = () => {
    const params = new URLSearchParams(searchParams?.toString());

    if (params.has(OPEN_SOFTPULL_QUERY_PARAM)) {
      params.delete(OPEN_SOFTPULL_QUERY_PARAM);

      const queryParams = params.toString();
      const newUrl = queryParams ? `${pathname}?${queryParams}` : pathname;

      // Must use native window history to prevent RSC fetching loop caused by reverse proxy
      window.history.replaceState({ scroll: false }, '', newUrl);
    }
  };

  useCoreEvents(eventNames.softpullModal.success, async () => {
    softpullSuccessState.current = true;
    // refresh terms on success for prequalified users
    if (!isMarketingPage) {
      await refreshTerms();
    }
  });
  useCoreEvents(eventNames.softpullModal.close, () => {
    clearSoftpullQueryParam();
    // reload page for non-prequalified users after modal is successfully completed and closed
    if (isMarketingPage && softpullSuccessState.current) {
      window.location.reload();
    }
    softpullSuccessState.current = false;
  });

  useEffect(() => {
    const autoPopModal = () => {
      const shouldOpenSoftpull =
        searchParams?.has('utm_source') ||
        searchParams?.get(OPEN_SOFTPULL_QUERY_PARAM) === 'true';

      if (
        isMarketingPage &&
        !isNative &&
        !searchParams?.has('openAccountModal') &&
        shouldOpenSoftpull
      ) {
        setSoftPullModalOpen(true);
      }
    };

    autoPopModal();
  }, [isMarketingPage, isNative, pathname, searchParams, setSoftPullModalOpen]);
}
